import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from '@jouzen/ecom-components/v3/Accordion';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import getValues from '@/app/[locale]/membership/utils/getValues';

import MembershipAccordionContent from './MembershipAccordionContent';
import MembershipAccordionHeader from './MembershipAccordionHeader';

const values = getValues();

const MembershipFAQ = () => {
  const t = useTranslations();

  return (
    <section
      className={cx(
        'bg-sandstone-100 text-sandstone-500',
        'relative py-20 lg:px-5 lg:py-24',
      )}
      data-cy="membership-faq"
    >
      <LayoutGrid>
        <GridItem
          colStart={{ sm: 'main', lg: 'main' }}
          colEnd={{ sm: 'main', lg: 'main' }}
        >
          <Typography
            Element="h2"
            variant="h3"
            className={cx(
              'text-sandstone-500',
              'text-4xl lg:mb-10 lg:text-5xl',
            )}
            data-cy="membership_faq_title"
          >
            {t('membership_faq_title')}
          </Typography>
          <Accordion variant="light">
            <AccordionHeader>
              <MembershipAccordionHeader
                headerMsgKey="membership_faq_question_1"
                dataCy="membership-faq-question-1"
              />
            </AccordionHeader>
            <AccordionContent>
              <MembershipAccordionContent
                contentMsgKey="membership_faq_answer_1"
                dataCy="membership-faq-answer-1"
              />
            </AccordionContent>

            <AccordionHeader>
              <MembershipAccordionHeader headerMsgKey="membership_faq_question_2" />
            </AccordionHeader>
            <AccordionContent>
              <MembershipAccordionContent contentMsgKey="membership_faq_answer_2" />
            </AccordionContent>

            <AccordionHeader>
              <MembershipAccordionHeader headerMsgKey="membership_faq_question_3" />
            </AccordionHeader>
            <AccordionContent>
              <MembershipAccordionContent
                contentMsgKey="membership_faq_answer_3_site_redesign"
                values={values}
              />
            </AccordionContent>

            <AccordionHeader>
              <MembershipAccordionHeader headerMsgKey="membership_faq_question_4" />
            </AccordionHeader>
            <AccordionContent>
              <MembershipAccordionContent contentMsgKey="membership_faq_answer_4" />
            </AccordionContent>

            <AccordionHeader>
              <MembershipAccordionHeader headerMsgKey="membership_faq_question_5" />
            </AccordionHeader>
            <AccordionContent>
              <MembershipAccordionContent
                contentMsgKey="membership_faq_answer_5_site_redesign"
                values={values}
              />
            </AccordionContent>

            <AccordionHeader>
              <MembershipAccordionHeader headerMsgKey="membership_faq_question_6" />
            </AccordionHeader>
            <AccordionContent>
              <MembershipAccordionContent contentMsgKey="membership_faq_answer_6_onemonth" />
            </AccordionContent>

            <AccordionHeader>
              <MembershipAccordionHeader headerMsgKey="membership_faq_question_7" />
            </AccordionHeader>
            <AccordionContent>
              <MembershipAccordionContent contentMsgKey="membership_faq_answer_7" />
            </AccordionContent>
          </Accordion>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default MembershipFAQ;
